import React from "react";
const Dependents = ({
    recieveIncomeback,
    onSelectAnswer,
    backClick
}) => {
    const optionClicked = async (e) => {
        onSelectAnswer(e);
    };
    let toggle = "";
    if (recieveIncomeback == "267") {
        toggle = "monthlyincome";
        
    } else {
        toggle = "recieveanyincome";
    }
    return (
        <>
            <div className="question-content mt-0 scale-down-ver-center px-3 py-lg-3 py-md-3 py-sm-2 py-2 ">
                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className="btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                                onClick={optionClicked}
                                value="146"
                                name="dependents"
                                id="nextscrolla"
                                data-quest-id={3}
                                data-ans-id={7}
                                data-ans-label={"0"}
                            >0
                            </button>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className="btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                                onClick={optionClicked}
                                value="142"
                                name="dependents"
                                id="nextscrolla"
                                data-quest-id={3}
                                data-ans-id={8}
                                data-ans-label={"1"}
                            >1
                            </button>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className="btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                                onClick={optionClicked}
                                value="143"
                                name="dependents"
                                id="nextscrolla"
                                data-quest-id={3}
                                data-ans-id={9}
                                data-ans-label={"2"}
                            >2
                            </button>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className="btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                                onClick={optionClicked}
                                value="144"
                                name="dependents"
                                id="nextscrolla"
                                data-quest-id={3}
                                data-ans-id={279}
                                data-ans-label={"3"}
                            >3
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className="btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                                onClick={optionClicked}
                                value="146"
                                name="dependents"
                                id="nextscrolla"
                                data-quest-id={3}
                                data-ans-id={280}
                                data-ans-label={"4"}
                            >4
                            </button>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className=" mb-2">
                            <button
                                type="button"
                                className="btn-comm2 py-lg-3 py-md-3 py-sm-2 py-2 w-100 nextBtn"
                                onClick={optionClicked}
                                value="142"
                                name="dependents"
                                id="nextscrolla"
                                data-quest-id={3}
                                data-ans-id={281}
                                data-ans-label={"4+"}
                            >4+
                            </button>
                        </div>
                    </div>
                </div>
                <p className="text-center bck-marwid">
                    <button
                        name={toggle}
                        className="mt-1 btn btn-secondary backbtn1a"
                        id=""
                        value=""
                        type="button"
                        onClick={backClick}

                    >Go Back</button>
                </p>
            </div>
        </>
    )
}
export default Dependents; 